import { Drawer, styled, Typography } from "@mui/material";
import { LocationForm } from "@features/locations/components/forms/LocationForm/LocationForm";

interface CreateLocationDrawerProps {
  open: boolean;
  onClose: () => void;
}

export const CreateLocationDrawer = ({
  open,
  onClose,
}: CreateLocationDrawerProps) => {
  return (
    <Drawer anchor={"right"} open={open} onClose={onClose}>
      <SideDrawerContainer>
        <Header>
          <Typography variant="h5">{"Create Location"}</Typography>
        </Header>
        <LocationForm handleClose={onClose} createFromStockView />
      </SideDrawerContainer>
    </Drawer>
  );
};

const Header = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "0 16px",
  height: "64px",
  borderBottom: `1px solid ${theme.palette.divider}`,
}));

const SideDrawerContainer = styled("div")(({ theme }) => ({
  width: "100vw",
  position: "relative",
  height: "100%",
  backgroundColor: theme.palette.background.default,
  [theme.breakpoints.up("lg")]: {
    width: "500px",
  },
}));
